import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { UpdatePayrollUser } from '../../../../../../reduxToolkit/PayrollPolicy/PayrollPolicyApi';
import {
    EMPTY_VALUES, errorMsg,
    currencyFormat, getDateFormat, DATE_TIME_FORMAT_NAME_MODEL, getTimeFormat
} from '../../../../../../Apis/functions';
import { SEARCH_MODEL } from '../../../../../../components/table/Model/TableModel';
import CustomTh from '../../../../../../components/table/CustomTh';
import CustomTd from '../../../../../../components/table/CustomTd';
import {DetailsIconsOptions, IconClockTable, IconScheduleTable} from '../../../../../../components/buttons/IconButtons';
import DropDownMenuProfile from '../../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../../components/DropDown/DropDownMenuItem';
import { SimpleSearch } from '../../../../../../reduxToolkit/Search/SearchApi';
import TableFunction from '../../../../../../components/table/TableFunction';
import { ATTENDANCE_SUBVIEW_MODEL } from '../../Model/Model';
import routes from "../../../../../../Routes/routes";
import CustomChip from "../../../../../../components/CustomChip";
import {colors} from "../../../../../../enums/colors";
import {toast} from "react-toastify";
import {ErrorCode} from "../../../../../../Apis/ErrorCode";
import {GetAttendancePeriodActive} from "../../../../../../reduxToolkit/AttendanceAdjustment/AttendanceAdjustmentApi";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PayrollActiveTableApp = ({
    searchElement,
    setBodyForExport,
    option,
    modified,
    setModified,
    activeStep,
    registerAction,
    subView
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tableId = 'tbl_pat_payroll_active';
    const searchId = 'txt_pat_payroll_active';
    const {getAttendancePeriodActive} = useSelector((state) => state.AttendanceAdjustmentSlice);

    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const [textNotInformation, setTextNotInformation] = useState('no_records_available');
    const periodStart = `${getDateFormat(getAttendancePeriodActive?.startDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)} ${getTimeFormat(getAttendancePeriodActive?.startDate, DATE_TIME_FORMAT_NAME_MODEL.HHmmss)}`;
    const periodEnd = getDateFormat(getAttendancePeriodActive?.endDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth);
    const periodEndTime = getTimeFormat(getAttendancePeriodActive?.endDate, DATE_TIME_FORMAT_NAME_MODEL.HHmmss);


    useEffect(() => {
        registerAction?.(ATTENDANCE_SUBVIEW_MODEL.PAYROLL.ACTIVE, { handleUpdate: () => dispatch(UpdatePayrollUser())
            .then(({ payload: { data: { success, code } } }) => {
                if (success === true){
                    setModified(true);
                    toast.success(t('has_been_updated_successfully'));
                }else{
                    errorMsg(code);
                }
            })
        });
        dispatch(GetAttendancePeriodActive());
    }, []);

    const getThead = () => [
        <CustomTh tableId={tableId} classes={"first-head"}>{t('name')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('department')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('calculated_at')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('base_salary')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('total_earnings')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('gross_salary')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('total_deductions')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('net_pay')}</CustomTh>,
    ];

    const getTbody = () => {
        if (!results?.content?.length) return { body: [], data: [] };

        const body = results.content.map((row) => (
            <>
                <CustomTd tableId={tableId} classes={"first-column"}>
                    {row?.fullName}
                </CustomTd>
                <CustomTd tableId={tableId}>
                    {row?.department ?  <CustomChip
                        background={colors.secondary100}
                        borderColor={colors.secondary150}
                        fontColor={colors.secondary700}
                        legend={row?.department}
                    />: EMPTY_VALUES.DEFAULT}
                </CustomTd>
                <CustomTd tableId={tableId}>
                    <div className={"d-flex align-items-center mb-1"}>
                        <IconScheduleTable className={"mr-8px icon-color-general-950"}/>
                        {getDateFormat(row?.calculatedAt,false)}
                    </div>
                    <div className={"d-flex align-items-center"}>
                        <IconClockTable className={"mr-8px icon-color-general-950"}/>
                        {getTimeFormat(row?.calculatedAt)}
                    </div>
                </CustomTd>
                <CustomTd tableId={tableId}>
                    {`$${currencyFormat(row?.baseSalary)}`}
                </CustomTd>
                <CustomTd tableId={tableId}>
                    {`$${currencyFormat(row?.totalOvertime)}`}
                </CustomTd>
                <CustomTd tableId={tableId}>
                    {`$${currencyFormat(row?.grossSalary)}`}
                </CustomTd>
                <CustomTd tableId={tableId}>
                    <span className={"font-color-accent-550 ibl-font-w-600"}>{`-$${currencyFormat(row?.totalDeductions)}`}</span>
                </CustomTd>
                <CustomTd tableId={tableId}>
                    <span className={"ibl-font-w-600"}>{`$${currencyFormat(row?.netPay)}`}</span>
                </CustomTd>
            </>
        ));

        return { body, data: results.content };
    };

    const getActionsButtons = (row, index) => (
        <DropDownMenuProfile
            openMenu={openMenu}
            handleMenuToggle={handleMenuToggle}
            menuId={`menu-pat-${row?.userId}`}
        >
            <DropDownMenuItem
                id={`btn_pat_detail_${row?.userId}`}
                index={index}
                handleClose={handleClose}
                name={t('details')}
                click={() => navigate(routes.payrollUser.details, { state: {
                    userId: row?.userId,
                    payrollResultId: row?.id,
                    currentTab: activeStep,
                    currentSubView: subView,
                } })}
                icon={<DetailsIconsOptions />}
            />
        </DropDownMenuProfile>
    );

    const getData = (page, { searchElement }) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
        });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success, code } } }) => {
            if (success === true){
                setResults(data);
            }else{
                if(code === ErrorCode.THERE_IS_NO_ACTIVE_ATTENDANCE_PERIOD){
                    setTextNotInformation('there_not_period_active');
                }else{
                    errorMsg(code)
                }
            }
        });
    };

    const { thead, tbody, t, pagination, rowsPerPage, openMenu, handleMenuToggle, handleClose } = TableFunction({
        getTbody,
        getThead,
        data: results,
        labelRowsPerPage: 'employees_per_page',
        hasContainer: true,
        fixedPagination: false,
        searchElement,
        getData,
        modified,
        setModified,
    });

    return {
        t,
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        textNotInformation,
        periodStart,
        periodEnd,
        periodEndTime
    };
};

export default PayrollActiveTableApp;
